import { render, staticRenderFns } from "./amountReviewFields.vue?vue&type=template&id=ca4e90d0&scoped=true"
import script from "./amountReviewFields.vue?vue&type=script&lang=js"
export * from "./amountReviewFields.vue?vue&type=script&lang=js"
import style0 from "./amountReviewFields.vue?vue&type=style&index=0&id=ca4e90d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4e90d0",
  null
  
)

export default component.exports